import { q25, q75, q50 } from '../../activity-aggregation/utils/data-compare';

export function aggregateNodes(chapterData) {
  let xAxisDataLabel = [];
  let xAxisData = [];
  let scoreList = [];
  let timeList = [];
  let quartile1ScoreList = [];
  let quartile3ScoreList = [];
  let quartile1TimeList = [];
  let quartile3TimeList = [];
  let medianList = [];
  //console.log("Here 0" , chapterData)
  if (!chapterData) {
    //console.log("Here 1")
    return {
      timeList,
      scoreList,
      xAxisData,
      xAxisDataLabel,
      quartile1ScoreList,
      quartile3ScoreList,
      quartile1TimeList,
      quartile3TimeList,
    };
  }
  chapterData.sort(function(a, b) {
    return a.position_in_chapter - b.position_in_chapter;
  });
  let wsIdx = 0;
  chapterData.forEach((nodeObj, idx) => {
    wsIdx += 1;
    nodeObj.activity_aggregate.forEach((activityAgg, i) => {
      //Link To Activity Level Dashboard
      let activityLink = ''.concat(
        "<a href='/activity-analytics/",
        activityAgg._id,
        "'>",
        activityAgg.activity_reference,
        '_',
        (i + 1).toString(),
        '</a>',
      );
      xAxisData.push(wsIdx);
      scoreList.push(
        q50(Object.values(activityAgg.distribution_score)) / activityAgg.max_score,
      );
      timeList.push(q50(Object.values(activityAgg.distribution_time)) / 60.0);
      quartile1ScoreList.push(
        q25(Object.values(activityAgg.distribution_score)) / activityAgg.max_score,
      );
      quartile3ScoreList.push(
        q75(Object.values(activityAgg.distribution_score)) / activityAgg.max_score,
      );
      quartile1TimeList.push(q25(Object.values(activityAgg.distribution_time)) / 60.0);
      quartile3TimeList.push(q75(Object.values(activityAgg.distribution_time)) / 60.0);
      xAxisDataLabel.push(activityLink);
    });
  });
  // console.log('quartile1TimeList ', quartile1TimeList);

  return {
    timeList,
    scoreList,
    xAxisData,
    xAxisDataLabel,
    quartile1ScoreList,
    quartile1TimeList,
    quartile3ScoreList,
    quartile3TimeList,
    medianList,
  };
}

export function extractDataForNode(node) {
  let medianScore;
  let q1Score;
  let q3Score;
  let medianTime;
  let q1Time;
  let q3Time;
  let worksheetLink;
  let worksheetReference;
  let numDataPoints;
  let maxScore;
  let attemptLocation = node.attempt_location;
  let positionInChapter = node.position_in_chapter;
  //console.log('node', node);
  if (node.activity_aggregate.length === 1) {
    maxScore = node.activity_aggregate[0].max_score;
    medianScore = q50(Object.values(node.activity_aggregate[0].distribution_score));
    medianTime = q50(Object.values(node.activity_aggregate[0].distribution_time));
    q1Score = q25(Object.values(node.activity_aggregate[0].distribution_score));
    q3Score = q75(Object.values(node.activity_aggregate[0].distribution_score));
    q1Time = q25(Object.values(node.activity_aggregate[0].distribution_time));
    q3Time = q75(Object.values(node.activity_aggregate[0].distribution_time));
    worksheetLink = ''.concat(
      "<a href='/activity-analytics/",
      node.activity_aggregate[0]._id,
      "'>WS_",
      node.position_in_chapter.toString(),
      '_',
      (+1).toString(),
      '</a>',
    );
  }

  // else if(node.activityAggregation.length === 2)  {
  //   Pass.;
  // }
  let outObj = {
    medianScore,
    q1Score,
    q3Score,
    medianTime,
    q1Time,
    q3Time,
    worksheetLink,
    worksheetReference,
    positionInChapter,
    attemptLocation,
    numDataPoints,
    maxScore,
  };
  return outObj;
}
